import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ClosingSideDrawerComponent,
  SideDrawerContentDirective,
  SideDrawerFooterDirective,
  SideDrawerTitleActionsDirective,
} from './closing-side-drawer/closing-side-drawer.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

import { ProductAnalyticsModule } from '@vendasta/product-analytics';
import {
  DYNAMIC_OPEN_CLOSE_TEMPLATE_DATA,
  DynamicOpenCloseTemplateRefService,
} from './dynamic-open-close-template-ref.service';
import { MatSidenavModule } from '@angular/material/sidenav';
import { SideDrawerContainerComponent } from './side-drawer-container/side-drawer-container.component';

@NgModule({
  declarations: [
    ClosingSideDrawerComponent,
    SideDrawerContentDirective,
    SideDrawerFooterDirective,
    SideDrawerTitleActionsDirective,
    SideDrawerContainerComponent,
  ],
  imports: [CommonModule, MatToolbarModule, MatIconModule, MatButtonModule, ProductAnalyticsModule, MatSidenavModule],
  exports: [
    ClosingSideDrawerComponent,
    SideDrawerContentDirective,
    SideDrawerFooterDirective,
    SideDrawerTitleActionsDirective,
    SideDrawerContainerComponent,
  ],
  providers: [
    {
      provide: DYNAMIC_OPEN_CLOSE_TEMPLATE_DATA,
      useFactory: DynamicOpenCloseTemplateRefService.dynamicOpenCloseTemplateData$,
      deps: [DynamicOpenCloseTemplateRefService],
    },
  ],
})
export class GalaxySideDrawerModule {}
